import { useState, useEffect } from 'react';

const T = {
  bg:'#06060d',s1:'#0d0c18',s2:'#12111e',s3:'#181628',
  border:'rgba(255,255,255,0.07)',border2:'rgba(255,255,255,0.13)',
  gold:'#d4a853',text:'#f0ead8',text2:'#9890b0',text3:'#55506a',
  blue:'#3b82f6',cyan:'#06b6d4',emerald:'#10b981',error:'#ef4444',
};

const ARTISANS = [
  {id:'a1',name:'Jerone Arnold Darden',handle:'@firekeeper_jeada',av:'🔥',crafts:['Actor','Model','Stage Manager','Photographer','Singer'],loc:'Bethlehem, PA',dist:'0.3 mi',ver:74,cl:82,avail:true,bio:'Multi-hyphenate creative. 2x Runway Royalty. Mr. NEPA Fashion Week 2026.',perms:['Follow','Request Booking','View Portfolio']},
  {id:'a2',name:'Ava Chen',handle:'@ava.lens',av:'📷',crafts:['Photographer','Videographer'],loc:'Bethlehem, PA',dist:'1.2 mi',ver:82,cl:84,avail:true,bio:'Editorial and commercial photographer.',perms:['Follow','Request Booking','View Portfolio','Message']},
  {id:'a3',name:'Dean Oluwafemi',handle:'@dean.stage',av:'🎭',crafts:['Stage Manager','Production Coordinator'],loc:'Allentown, PA',dist:'6.4 mi',ver:88,cl:88,avail:true,bio:'Stage management across equity and non-equity productions.',perms:['Follow','View Portfolio']},
  {id:'a4',name:'Priya Nair',handle:'@priya.costume',av:'✂️',crafts:['Costume Designer','Stylist'],loc:'Allentown, PA',dist:'7.1 mi',ver:78,cl:79,avail:true,bio:'Theatrical and editorial costume design.',perms:['Follow','Request Booking','View Portfolio']},
  {id:'a5',name:'Sofia Reyes',handle:'@sofia.voice',av:'🎤',crafts:['Singer','Vocal Coach'],loc:'Easton, PA',dist:'14.8 mi',ver:74,cl:76,avail:true,bio:'Classical and jazz vocalist. Available for session work and coaching.',perms:['Follow','View Portfolio']},
  {id:'a6',name:'Marcus Webb',handle:'@marcus.directs',av:'🎬',crafts:['Director','Producer'],loc:'New York, NY',dist:'28.3 mi',ver:91,cl:91,avail:false,bio:'Independent filmmaker. Currently in pre-production.',perms:['Follow','View Portfolio']},
];

const EVENTS = [
  {name:'NEPA Fashion Week — Day 1',date:'May 15, 2026',loc:'Scranton, PA',type:'Fashion',tickets:'$35–$85',em:'🎪',artisans:['@priya.costume','@sofia.voice']},
  {name:'NEPA Fashion Week — Day 2 (Crowning Night)',date:'May 16, 2026',loc:'Scranton, PA',type:'Fashion',tickets:'$45–$95',em:'👑',artisans:['@firekeeper_jeada','@priya.costume']},
  {name:'ArtsQuest Summer Series',date:'June 7, 2026',loc:'SteelStacks, Bethlehem PA',type:'Multi-Art',tickets:'$0–$20',em:'🎭',artisans:['@ava.lens','@dean.stage']},
  {name:'Brooklyn en Vogue',date:'June 13, 2026',loc:'Brooklyn, NY',type:'Fashion',tickets:'$50',em:'🌆',artisans:['@firekeeper_jeada']},
];

const MAP_POSITIONS = [
  {id:'a1',x:'38%',y:'48%'},{id:'a2',x:'43%',y:'52%'},
  {id:'a3',x:'28%',y:'45%'},{id:'a4',x:'30%',y:'55%'},
  {id:'a5',x:'62%',y:'40%'},{id:'a6',x:'75%',y:'65%'},
];

const ALL_CRAFTS = ['All','Actor','Model','Photographer','Videographer','Singer','Director','Stage Manager','Costume Designer','Stylist','Vocal Coach','Producer'];

function ScorePill({ label, value, color }) {
  return (
    <span style={{ fontSize:10, padding:'2px 6px', borderRadius:4, background:`${color}15`, color, fontFamily:'monospace' }}>
      {label} {value}
    </span>
  );
}

function ArtisanCard({ a, onClick }) {
  return (
    <div onClick={() => onClick(a)} style={{ background:T.s2, border:`1px solid ${T.border2}`, borderRadius:12, padding:'1rem', cursor:'pointer', transition:'border-color .15s' }}
      onMouseEnter={e => e.currentTarget.style.borderColor = T.gold}
      onMouseLeave={e => e.currentTarget.style.borderColor = T.border2}>
      <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:10 }}>
        <div style={{ width:44, height:44, borderRadius:'50%', background:T.s3, display:'flex', alignItems:'center', justifyContent:'center', fontSize:22, border:`2px solid ${a.avail ? T.emerald : T.border2}`, flexShrink:0 }}>{a.av}</div>
        <div style={{ flex:1, minWidth:0 }}>
          <div style={{ fontWeight:600, fontSize:14, color:T.text, marginBottom:2 }}>{a.name}</div>
          <div style={{ fontSize:11, color:T.text3 }}>{a.handle} · {a.loc}</div>
        </div>
        <span style={{ fontSize:10, padding:'2px 6px', borderRadius:20, background: a.avail ? `${T.emerald}20` : `${T.text3}20`, color: a.avail ? T.emerald : T.text3, whiteSpace:'nowrap' }}>
          {a.avail ? '● Available' : '○ Unavailable'}
        </span>
      </div>
      <div style={{ display:'flex', flexWrap:'wrap', gap:4, marginBottom:8 }}>
        {a.crafts.slice(0,3).map(c => (
          <span key={c} style={{ fontSize:10, padding:'2px 8px', borderRadius:20, background:`${T.blue}15`, color:T.blue }}>{c}</span>
        ))}
        {a.crafts.length > 3 && <span style={{ fontSize:10, color:T.text3 }}>+{a.crafts.length-3}</span>}
      </div>
      <div style={{ display:'flex', gap:6, justifyContent:'space-between', alignItems:'center' }}>
        <div style={{ display:'flex', gap:6 }}>
          <ScorePill label="VER" value={a.ver} color={T.cyan} />
          <ScorePill label="CL" value={a.cl} color={T.gold} />
        </div>
        <span style={{ fontSize:11, color:T.text3, fontFamily:'monospace' }}>{a.dist}</span>
      </div>
    </div>
  );
}

function ProfileDrawer({ artisan, onClose }) {
  if (!artisan) return null;
  return (
    <div style={{ position:'fixed', inset:0, zIndex:1500, display:'flex', justifyContent:'flex-end' }} onClick={onClose}>
      <div style={{ width:'100%', maxWidth:400, height:'100%', background:T.s1, border:`1px solid ${T.border2}`, overflowY:'auto', padding:'1.5rem', boxShadow:'-8px 0 40px rgba(0,0,0,0.6)' }}
        onClick={e => e.stopPropagation()}>
        <button onClick={onClose} style={{ background:'none', border:`1px solid ${T.border2}`, color:T.text2, borderRadius:8, padding:'6px 12px', fontSize:12, cursor:'pointer', marginBottom:'1.5rem', fontFamily:'inherit' }}>✕ Close</button>
        <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:'1rem' }}>
          <div style={{ width:60, height:60, borderRadius:'50%', background:T.s3, display:'flex', alignItems:'center', justifyContent:'center', fontSize:28, border:`2px solid ${T.gold}` }}>{artisan.av}</div>
          <div>
            <div style={{ fontFamily:'Cormorant Garamond, serif', fontSize:22, fontWeight:700, color:T.text }}>{artisan.name}</div>
            <div style={{ fontSize:12, color:T.text3 }}>{artisan.handle} · {artisan.loc}</div>
          </div>
        </div>
        <div style={{ display:'flex', gap:8, marginBottom:'1rem' }}>
          <ScorePill label="Verification" value={artisan.ver} color={T.cyan} />
          <ScorePill label="Craft Line" value={artisan.cl} color={T.gold} />
          <span style={{ fontSize:10, padding:'2px 8px', borderRadius:20, background: artisan.avail?`${T.emerald}20`:`${T.text3}20`, color: artisan.avail?T.emerald:T.text3 }}>
            {artisan.avail ? '● Available' : '○ Unavailable'}
          </span>
        </div>
        <p style={{ fontSize:13, color:T.text2, lineHeight:1.65, marginBottom:'1rem' }}>{artisan.bio}</p>
        <div style={{ display:'flex', flexWrap:'wrap', gap:4, marginBottom:'1.25rem' }}>
          {artisan.crafts.map(c => (
            <span key={c} style={{ fontSize:11, padding:'3px 10px', borderRadius:20, background:`${T.blue}15`, color:T.blue }}>{c}</span>
          ))}
        </div>
        <div style={{ marginBottom:'1.25rem' }}>
          <div style={{ fontSize:11, color:T.text3, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:8 }}>Permissions</div>
          {artisan.perms.map(p => (
            <div key={p} style={{ display:'flex', alignItems:'center', gap:8, marginBottom:6, fontSize:13, color:T.text2 }}>
              <span style={{ color:T.emerald }}>✓</span>{p}
            </div>
          ))}
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
          {artisan.perms.includes('Follow') && (
            <button style={{ padding:'0.7rem', borderRadius:8, border:`1px solid ${T.gold}`, background:'none', color:T.gold, fontSize:13, fontWeight:600, cursor:'pointer', fontFamily:'inherit' }}>Follow</button>
          )}
          {artisan.perms.includes('Request Booking') && (
            <button style={{ padding:'0.7rem', borderRadius:8, border:'none', background:T.gold, color:T.bg, fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' }}>Request Booking</button>
          )}
          {artisan.perms.includes('Message') && (
            <button style={{ padding:'0.7rem', borderRadius:8, border:`1px solid ${T.border2}`, background:'none', color:T.text2, fontSize:13, cursor:'pointer', fontFamily:'inherit' }}>Message</button>
          )}
        </div>
      </div>
    </div>
  );
}

export default function AisleView() {
  const [view, setView] = useState('discover');
  const [search, setSearch] = useState('');
  const [craftFilter, setCraftFilter] = useState('All');
  const [selected, setSelected] = useState(null);
  const [showPledge, setShowPledge] = useState(false);

  const filtered = ARTISANS.filter(a => {
    const q = search.toLowerCase();
    const matchSearch = !q || a.name.toLowerCase().includes(q) || a.handle.toLowerCase().includes(q) || a.crafts.some(c => c.toLowerCase().includes(q)) || a.loc.toLowerCase().includes(q);
    const matchCraft = craftFilter === 'All' || a.crafts.includes(craftFilter);
    return matchSearch && matchCraft;
  });

  const navBtn = (id, label) => (
    <button key={id} onClick={() => setView(id)} style={{ padding:'6px 16px', borderRadius:20, fontSize:12, fontWeight:600, cursor:'pointer', fontFamily:'inherit', border:`1px solid ${view===id ? T.gold : T.border2}`, background: view===id ? `${T.gold}15` : 'none', color: view===id ? T.gold : T.text2, transition:'all .15s' }}>
      {label}
    </button>
  );

  return (
    <div style={{ maxWidth:900, margin:'0 auto' }}>
      {/* Header */}
      <div style={{ marginBottom:'1.25rem' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:4 }}>
          <div style={{ fontFamily:'Cormorant Garamond, serif', fontSize:28, fontWeight:700, color:T.gold }}>Aisle</div>
          <span style={{ fontSize:11, padding:'2px 8px', borderRadius:20, background:`${T.cyan}15`, color:T.cyan, fontFamily:'monospace' }}>PUBLIC</span>
        </div>
        <p style={{ fontSize:13, color:T.text2 }}>Discover verified creative talent near you</p>
      </div>

      {/* Nav tabs */}
      <div style={{ display:'flex', gap:8, marginBottom:'1rem' }}>
        {navBtn('discover','◎ Discover')}
        {navBtn('map','◉ Map')}
        {navBtn('events','◈ Events')}
      </div>

      {/* Search + filter (discover + map only) */}
      {view !== 'events' && (
        <div style={{ display:'flex', gap:8, marginBottom:'1rem', flexWrap:'wrap' }}>
          <input
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Search by name, craft, or location..."
            style={{ flex:1, minWidth:200, background:T.s2, border:`1px solid ${T.border2}`, borderRadius:8, padding:'8px 12px', color:T.text, fontSize:13, fontFamily:'inherit', outline:'none' }}
          />
          <select
            value={craftFilter}
            onChange={e => setCraftFilter(e.target.value)}
            style={{ background:T.s2, border:`1px solid ${T.border2}`, borderRadius:8, padding:'8px 12px', color:T.text, fontSize:13, fontFamily:'inherit', cursor:'pointer' }}
          >
            {ALL_CRAFTS.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
      )}

      {/* DISCOVER VIEW */}
      {view === 'discover' && (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))', gap:16 }}>
          {filtered.length === 0 && (
            <div style={{ gridColumn:'1/-1', textAlign:'center', padding:'4rem 2rem', color:T.text3 }}>
              <div style={{ fontSize:36, marginBottom:12 }}>◎</div>
              <div style={{ fontSize:15, fontWeight:600, color:T.text2, marginBottom:6 }}>No artisans found</div>
              <div style={{ fontSize:13 }}>Try a different search or craft filter.</div>
            </div>
          )}
          {filtered.map(a => <ArtisanCard key={a.id} a={a} onClick={setSelected} />)}
        </div>
      )}

      {/* MAP VIEW */}
      {view === 'map' && (
        <div style={{ background:T.s2, border:`1px solid ${T.border2}`, borderRadius:12, overflow:'hidden', position:'relative', height:500 }}>
          {/* Simulated map grid */}
          <div style={{ position:'absolute', inset:0, opacity:0.06 }}>
            {Array.from({length:10}).map((_,i) => (
              <div key={i} style={{ position:'absolute', left:0, right:0, top:`${i*10}%`, height:1, background:T.gold }} />
            ))}
            {Array.from({length:10}).map((_,i) => (
              <div key={i} style={{ position:'absolute', top:0, bottom:0, left:`${i*10}%`, width:1, background:T.gold }} />
            ))}
          </div>
          <div style={{ position:'absolute', top:'50%', left:'50%', transform:'translate(-50%,-50%)', width:8, height:8, borderRadius:'50%', background:T.cyan, boxShadow:`0 0 0 20px ${T.cyan}20` }} />
          <div style={{ position:'absolute', bottom:12, left:12, fontSize:11, color:T.text3, fontFamily:'monospace' }}>◎ You are here — Bethlehem, PA</div>
          {MAP_POSITIONS.filter(p => filtered.find(a => a.id === p.id)).map(p => {
            const a = ARTISANS.find(x => x.id === p.id);
            return (
              <div key={p.id} onClick={() => setSelected(a)} style={{ position:'absolute', left:p.x, top:p.y, transform:'translate(-50%,-100%)', cursor:'pointer', textAlign:'center', transition:'transform .15s' }}
                onMouseEnter={e => e.currentTarget.style.transform='translate(-50%,-100%) scale(1.2)'}
                onMouseLeave={e => e.currentTarget.style.transform='translate(-50%,-100%)'}>
                <div style={{ fontSize:20, filter:'drop-shadow(0 2px 8px rgba(0,0,0,.5))' }}>{a.av}</div>
                <div style={{ fontSize:9, color:T.cyan, fontFamily:'monospace', marginTop:2 }}>{a.dist}</div>
              </div>
            );
          })}
        </div>
      )}

      {/* EVENTS VIEW */}
      {view === 'events' && (
        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          {EVENTS.map((ev, i) => (
            <div key={i} style={{ background:T.s2, border:`1px solid ${T.border2}`, borderRadius:12, padding:'1rem 1.25rem', display:'flex', gap:14, alignItems:'flex-start' }}>
              <div style={{ fontSize:32, flexShrink:0 }}>{ev.em}</div>
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:600, fontSize:14, color:T.text, marginBottom:4 }}>{ev.name}</div>
                <div style={{ fontSize:12, color:T.text3, marginBottom:6 }}>{ev.date} · {ev.loc}</div>
                <div style={{ display:'flex', gap:6, flexWrap:'wrap', alignItems:'center' }}>
                  <span style={{ fontSize:10, padding:'2px 8px', borderRadius:20, background:`${T.blue}15`, color:T.blue }}>{ev.type}</span>
                  <span style={{ fontSize:10, color:T.text3 }}>Tickets: {ev.tickets}</span>
                </div>
                {ev.artisans.length > 0 && (
                  <div style={{ marginTop:8, fontSize:11, color:T.text3 }}>
                    Featuring: {ev.artisans.join(', ')}
                  </div>
                )}
              </div>
              <button onClick={() => setShowPledge(true)} style={{ padding:'6px 14px', borderRadius:8, border:`1px solid ${T.gold}`, background:'none', color:T.gold, fontSize:11, fontWeight:600, cursor:'pointer', fontFamily:'inherit', whiteSpace:'nowrap' }}>
                Get Tickets
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Profile drawer */}
      <ProfileDrawer artisan={selected} onClose={() => setSelected(null)} />

      {/* Pledge gate */}
      {showPledge && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.85)', zIndex:2000, display:'flex', alignItems:'center', justifyContent:'center', padding:'1rem' }} onClick={() => setShowPledge(false)}>
          <div style={{ background:T.s1, border:`1px solid ${T.border2}`, borderRadius:16, maxWidth:420, width:'100%', padding:'2rem' }} onClick={e => e.stopPropagation()}>
            <div style={{ fontSize:36, marginBottom:12, textAlign:'center' }}>✦</div>
            <h2 style={{ fontFamily:'Cormorant Garamond, serif', fontSize:26, fontWeight:700, textAlign:'center', color:T.text, marginBottom:8 }}>Join as an Artisan</h2>
            <p style={{ fontSize:13, color:T.text2, textAlign:'center', lineHeight:1.65, marginBottom:'1.25rem' }}>Aisle is the public face of Artizan. To appear here, you need a verified Artizan account.</p>
            <div style={{ background:T.s2, border:`1px solid ${T.border2}`, borderRadius:10, padding:'1rem', marginBottom:'1.25rem' }}>
              <div style={{ fontSize:11, color:T.text3, textTransform:'uppercase', letterSpacing:'.06em', marginBottom:10 }}>The Artisan Pledge</div>
              {['I will represent my craft honestly and accurately','I will not use Aisle to harass, deceive, or harm','I understand this community is built on verified trust'].map(p => (
                <div key={p} style={{ display:'flex', gap:10, fontSize:13, color:T.text2, marginBottom:6 }}><span style={{ color:T.blue }}>✓</span>{p}</div>
              ))}
            </div>
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={() => setShowPledge(false)} style={{ flex:1, padding:'0.7rem', borderRadius:8, border:`1px solid ${T.border2}`, background:'none', color:T.text2, fontSize:13, cursor:'pointer', fontFamily:'inherit' }}>Maybe Later</button>
              <button onClick={() => setShowPledge(false)} style={{ flex:1, padding:'0.7rem', borderRadius:8, border:'none', background:T.blue, color:'white', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' }}>I Pledge — Create Account</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
